import Moment from "moment";

Moment.prototype.formatAsDurationOrDate = function(
    dateFormat = "LLL",
    maxDuration = Moment.duration(1, "day")
) {
    const now = Moment();
    const max = Moment(this).add(maxDuration);
    if (now.isBefore(max)) {
        return this.from(now);
    }
    return this.format(dateFormat);
};



// WEBPACK FOOTER //
// ./src/utils/moment.js